import { useRouter } from 'next/router';

export const useUrlQuery = () => {
  const router = useRouter();
  // router.asPath contains the full URL path including the query string.
  const queryString = router.asPath.split('?')[1] || '';
  return new URLSearchParams(queryString);
};
